import React, { useState } from 'react';
import '../styles/ChallengeModals.css';

function ChallengeAccept({ challenge, userBalance, onAccept, onCancel }) {
  const [confirming, setConfirming] = useState(false);
  const totalRisk = challenge.wager * challenge.num_games;
  const canAccept = totalRisk <= userBalance;

  const handleAccept = () => {
    setConfirming(true);
    onAccept();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content accept-challenge-modal">
        <div className="modal-header">
          <h2>Challenge from {challenge.creator_username}{challenge.creator_is_ai ? ' (AI Player)' : ''}</h2>
          <button className="close-btn" onClick={onCancel}>✕</button>
        </div>

        <div className="modal-body">
          <div className="challenge-terms">
            <h3>Challenge Terms</h3>
            
            <div className="term">
              <label>Opponent:</label>
              <span className="value">{challenge.creator_username}{challenge.creator_is_ai ? ' • AI Player' : ''}</span>
            </div>

            <div className="term">
              <label>Wager per game:</label>
              <span className="value amount">{challenge.wager} wikipenny</span>
            </div>

            <div className="term">
              <label>Number of games:</label>
              <span className="value">{challenge.num_games}</span>
            </div>

            <div className="term total">
              <label>Total at Risk:</label>
              <span className="value amount">{totalRisk} wikipenny</span>
            </div>

            <div className="divider"></div>

            <div className="what-happens">
              <h4>What happens if you accept?</h4>
              <ul>
                <li>✓ {totalRisk} wikipenny will be deducted from your balance</li>
                <li>✓ You'll play {challenge.num_games} games against {challenge.creator_username}</li>
                <li>✓ All games must be completed before you can play another challenge</li>
                <li>✓ The player with more wins gets all the wagers</li>
                <li>✓ If tied, both get their wagers back</li>
              </ul>
            </div>

            <div className="balance-check">
              <div className="balance-item">
                <span>Your Balance:</span>
                <strong>{userBalance} wikipenny</strong>
              </div>
              <div className="balance-item">
                <span>After accepting:</span>
                <strong className={userBalance - totalRisk < 0 ? 'error' : ''}>
                  {userBalance - totalRisk} wikipenny
                </strong>
              </div>
            </div>

            {!canAccept && (
              <div className="error-box">
                <p>❌ Insufficient balance to accept this challenge</p>
                <p>You need {totalRisk} wikipenny but only have {userBalance}</p>
              </div>
            )}
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn-cancel" onClick={onCancel}>Decline</button>
          <button 
            className="btn-primary" 
            onClick={handleAccept}
            disabled={!canAccept || confirming}
          >
            {confirming ? 'Accepting...' : 'Accept Challenge'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ChallengeAccept;

